import i18next from "i18next";
import { fetchTranslatedTips } from "./fetchTips";

import { isNullOrUndefined } from '../../../../services/util';
import { generateSubscores } from '../../util/generators/generateSubscores';
import { isBenchmarkAssessment } from '../../util/getActivityType';
import getLatestARMBox from '../../util/getLatestARMBox';
import { isPendingAssessment } from '../../util/pendingAssessment';
import getARMBoxes from './getARMBoxes';
import getLatestAssessments from './getLatestAssessments';

/**
 * The main function for fetching the parent report data
 * @param {*} student
 * @param {*} metric
 * @param {*} benchmark
 * @param {*} customBenchmarks
 * @param {*} equating
 * @param {*} locale
 * @returns all the data needed to render the parent report
 */
export async function fetchParentReport(student, metric, benchmark, customBenchmarks, reportConfig, equating, locale, selectedStatePercentileCuts, assessmentTypeFilter) {
  const t = i18next.getFixedT(null, 'teacher_parent_report');
  const studentId = student && student.value;
  const isBenchmarkOnly = assessmentTypeFilter === 'BENCHMARK_ONLY';

  /**
   * fetch all the data we need for the report
   */
  let assessments = await getLatestAssessments(studentId, equating, locale, 30);
  assessments = assessments.filter(assessment => !isPendingAssessment(assessment)); // filter out pending assessments
  if(isBenchmarkOnly){
    assessments = assessments.filter(isBenchmarkAssessment); // filter to only benchmark assessments
  }

  /**
   * generate report components
  */
  const isSpanishEarlyReader = assessments?.[0]?.displayStatus === 'prereader' && locale === 'ES-MX';
  const isEnglishEarlyReader = assessments?.[0]?.displayStatus === 'prereader' && locale === 'EN-US';
  const isEarlyReader = isSpanishEarlyReader || isEnglishEarlyReader;
  const useARM = selectedStatePercentileCuts && selectedStatePercentileCuts.state !== "US" && isEarlyReader;

  let subscores = null;
  if (reportConfig.isSubscoresVisible && !isSpanishEarlyReader) {
    subscores = await generateSubscores(studentId, locale, useARM, isEarlyReader, assessments, benchmark, customBenchmarks, isBenchmarkOnly);
  }

  /**
   * calculate the other report data
   */
  const armBoxes = await getARMBoxes(student, assessments, metric, benchmark, customBenchmarks, locale);
  const latestARMBox = getLatestARMBox(armBoxes);
  const {armScore, score} = latestARMBox;

  let tips = null;
  if (reportConfig.isTipsVisible) {
    tips = await fetchTranslatedTips(armScore, locale);
  }
  const reportNotAvailable =  isNullOrUndefined(score);

  /**
   * return the final report object
   */
  return {
    reportNotAvailable,
    armBoxes,
    subscores,
    tips,
  };
}